import React from "react"

const ContactBox = () => {
  return (
    <div className='contactBox mt-5'>
      <div className='wrapper flex alignItemsCenter'>
        Profesyonel su tesisatı hizmetlerine mi ihtiyacınız var? <br />
        Kaliteli hizmet almak için şimdi arayın!
        <div className='button3 ml-auto'>İLETİŞİM</div>
      </div>
    </div>
  )
}

export default ContactBox
